<template>
  <div class="with-sidebar">
    <div class="nav">
      <h2>Admin</h2>

      <router-link :to="{ name: 'AdminPortfolioList' }">
        <h3>Projects</h3>
      </router-link>

      <router-link :to="{ name: 'AdminSignupList' }">
        <h3>Signups</h3>
      </router-link>
    </div>

    <router-view/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'Admin',

  data: () => ({
    store,
  }),

  mounted() {
    const { token } = this.$route.query
    if (token) {
      store.setAdminToken(String(token))
    } else {
      console.error(new Error('Missing admin creds'))
      this.$router.push('/')
    }
  },
};
</script>

<style scoped lang="scss">
.nav {
  padding: 0.2rem 1rem;

  a {
    display: block;
    margin: 0.2rem 1rem;
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &.router-link-active {
      color: #99CC66;
      text-decoration: underline;
    }
  }
}
</style>
